import * as Yup from "yup";

export interface DashboardFormMetricsFields {
  metrics_show_section: boolean;
  metrics_for_all_checks: boolean;
}

export const DashboardFormMetricsSchema = Yup.object({
  metrics_show_section: Yup.boolean().required(),
  metrics_for_all_checks: Yup.boolean().required(),
});

export const DashboardFormMetricsDefaults = {
  metrics_show_section: true,
  metrics_for_all_checks: true,
};
